export default __webpack_public_path__ + "static/media/brands-topborder.8fc44cdc.svg";